import type { ComponentProps } from 'react';
import { Banner } from '@hotjar/hotsauce';

export interface DismissibleBannerProps {
  showBanner: boolean;
  message: string;
  kind: ComponentProps<typeof Banner>['kind'];
  onDismiss: ComponentProps<typeof Banner>['onDismiss'];
  className?: string;
}

export const DismissibleBanner = ({
  showBanner,
  message,
  kind,
  onDismiss = () => {
    // noop
  },
  className = '',
}: DismissibleBannerProps): JSX.Element | null =>
  showBanner ? (
    <Banner kind={kind} isDismissible onDismiss={onDismiss} className={className}>
      {message}
    </Banner>
  ) : null;
